import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  CURRENT_SUB_TENANT,
  CURRENT_SETTINGS,
  CURRENT_TENANT,
  CURRENT_USER,
  CURRENTS,
} from 'drapcode-constant';
import { snakeCaseToTitleCase } from '../../../../common/utils/api_utils';
import {
  supportedConditions,
  supportedValues,
  findTypeOfField,
  saveQueryUtil,
  showSaveButtonUtil,
  collectionRefFields,
  collectionRefFieldOption,
  isFieldIsCollectionRefField,
  dateConstantTypes,
} from './query-util';
import CustomSelect from '../../../home/collections/CustomSelect';
import { fetchFieldOfSelectedCollection, getItemsOfSelectedCollection } from './query-api';
import {
  IN_LIST,
  IS_NOT_NULL,
  IS_NULL,
  NOT_IN_LIST,
  DateTimeUnit,
  referenceTypeArray,
} from './query-constant';
import { iconForField } from '../../../../common/custom/icon-library';
import FilterFormParentComponent from './FilterFormParentComponent';
import { extractRefField } from '../../../../common/utils/field-options';
import { defaultFields2 } from '../../../../common/utils/constant';

export default class QueryCondition extends Component {
  static propTypes = {
    actions: PropTypes.object,
    collections: PropTypes.object,
    projectId: PropTypes.string,
    constants: PropTypes.array.isRequired,
    fields: PropTypes.array.isRequired,
    fieldOptions: PropTypes.array.isRequired,
    setFieldValue: PropTypes.func,
    setFieldTouched: PropTypes.func,
    condition: PropTypes.object,
    removeQuery: PropTypes.func,
    saveQuery: PropTypes.func,
  };

  state = {
    selectedField: null,
    selectedFieldError: '',
    selectedCondition: '',
    selectedConditionError: '',
    selectedValue: '',
    selectedValueMin: '',
    selectedValueMax: '',
    selectedValueError: '',
    conjuctionType: null,
    conjuctionTypeError: '',
    selectedValueCollection: '',
    selectedValueCollectionField: '',
    selectedCollectionFields: [],
    selectedCollectionFieldItems: [],
    selectedRefCollectionFieldItems: [],
    selectedCollectionFieldsValues: [],
    selectedCollectionFilters: [],
    selectedValueCollectionFieldValue: '',
    selectedValueCollectionFilterValue: '',
    choiceOfFieldSelect: null,
    minExternal: '',
    maxExternal: '',
    valueExternal: '',
    collectionFieldValueExternal: '',
    isMulti: false,
    selectedCurrentUserRefError: '',
    selectedCurrentUserRef: '',
    selectedCurrentUserRefFieldError: '',
    selectedCurrentUserRefField: '',
    multiTenantCollection: '',
    userSettingsCollection: '',
    subTenantCollection: '',
    collectionFieldItems: [],
  };

  removeQuery = () => {
    this.props.removeQuery(this.props.condition.id);
  };

  saveQuery = () => {
    const { condition } = this.props;
    const response = saveQueryUtil(this.props, this.state);
    console.log('response', response);
    const status = response.status;
    delete response['status'];
    if (status === 'ERROR') {
      this.setState(response);
    } else {
      this.props.saveQuery(condition.id, response);
    }
  };

  handleExternalKeyChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value ? value.trim().replaceAll(' ', '_') : value });
  };

  customSelectHandleChange = (name, value) => {
    const { plugins } = this.props.collections;
    const multiTenantPlugin = plugins && plugins.find((e) => e.code === 'MULTI_TENANT_SAAS');
    let multiTenantCollection = '';
    let userSettingsCollection = '';
    let subTenantCollection = '';
    if (
      multiTenantPlugin &&
      multiTenantPlugin.setting &&
      multiTenantPlugin.setting.multiTenantCollection
    )
      multiTenantCollection = multiTenantPlugin.setting.multiTenantCollection;
    if (
      multiTenantPlugin &&
      multiTenantPlugin.setting &&
      multiTenantPlugin.setting.userSettingsCollection
    )
      userSettingsCollection = multiTenantPlugin.setting.userSettingsCollection;
    if (
      multiTenantPlugin &&
      multiTenantPlugin.setting &&
      multiTenantPlugin.setting.subTenantCollection
    )
      subTenantCollection = multiTenantPlugin.setting.subTenantCollection;
    let isMulti = this.state.isMulti;
    let selectedCondition = this.state.selectedCondition;
    const isValueArray = Array.isArray(value);
    if (
      ['IN_LIST', 'NOT_IN_LIST'].includes(selectedCondition.value) &&
      name[0] === 'selectedValue' &&
      value
    ) {
      if ((isValueArray && CURRENTS.includes(value[0].value)) || CURRENTS.includes(value.value)) {
        isMulti = false;
        value = isValueArray ? value[0] : value;
      } else {
        isMulti = true;
        value = !isValueArray ? [value] : value;
      }
    }
    this.setState({
      [name]: value,
      selectedFieldError: '',
      selectedConditionError: '',
      selectedValueError: '',
      conjuctionTypeError: '',
      selectedCurrentUserRefError: '',
      selectedCurrentUserRefFieldError: '',
      multiTenantCollection,
      userSettingsCollection,
      subTenantCollection,
      isMulti,
    });
  };

  customConditionHandleChange = async (name, value) => {
    const {
      projectId,
      version,
      collections: { selectedCollection },
      fields,
    } = this.props;
    const { selectedField } = this.state;
    const targetValue = value ? value.value : '';
    const collectionFieldItems = [];
    let isMulti = false;
    if ([IN_LIST, NOT_IN_LIST].includes(targetValue)) {
      if (!['static_option', 'reference', 'dynamic_option'].includes(selectedField.type)) {
        const { data: collectionItems } = await getItemsOfSelectedCollection(
          projectId,
          selectedCollection.collectionName,
          version,
          [selectedField.value],
        );
        collectionItems.forEach((item) => {
          if (item[selectedField.value]) {
            collectionFieldItems.push({
              name: item[selectedField.value],
              value: item[selectedField.value],
              uuid: item.uuid,
            });
          }
        });
      }
      isMulti = true;
    } else {
      isMulti = false;
    }
    this.setState({
      [name]: value,
      selectedFieldError: '',
      selectedConditionError: '',
      selectedValueError: '',
      conjuctionTypeError: '',
      selectedValue: '',
      selectedValueMin: '',
      selectedValueMax: '',
      selectedValueCollection: '',
      selectedValueCollectionField: '',
      selectedValueCollectionFieldValue: '',
      selectedValueCollectionFilterValue: '',
      choiceOfFieldSelect: '',
      isMulti,
      collectionFieldItems,
    });
  };

  handleCollectionChange = async (name, value) => {
    const { collections, projectId, version } = this.props;
    const { multiTenantCollection, userSettingsCollection, subTenantCollection } = this.state;
    const { projectCollections } = collections;
    let selectedValueCollection = value ? value.value : '';
    let filteredCollection = {};
    if (selectedValueCollection === 'ENTITY') this.setState({ selectedValueCollection: value });
    if (selectedValueCollection === CURRENT_USER) selectedValueCollection = 'user';
    if (selectedValueCollection === CURRENT_TENANT) {
      filteredCollection = projectCollections.find(
        (collection) => collection.uuid === multiTenantCollection && collection.isTenantCollection,
      );
    }
    if (selectedValueCollection && selectedValueCollection !== 'ENTITY') {
      if (selectedValueCollection !== CURRENT_TENANT) {
        filteredCollection = projectCollections.find((colln) => {
          return colln.collectionName === selectedValueCollection;
        });
      }
      if (selectedValueCollection === CURRENT_SETTINGS) {
        filteredCollection = projectCollections.find(
          (collection) =>
            collection.uuid === userSettingsCollection && collection.isUserSettingCollection,
        );
      }
      if (selectedValueCollection === CURRENT_SUB_TENANT) {
        filteredCollection = projectCollections.find(
          (collection) =>
            collection.uuid === subTenantCollection && collection.isSubTenantCollection,
        );
      }
      if (filteredCollection) {
        const fields = await fetchFieldOfSelectedCollection(
          projectId,
          version,
          filteredCollection,
          name,
          value,
        );
        if (fields) {
          if (Object.keys(fields).length) {
            this.setState(fields);
          }
        }
      }
    }
  };

  handleFieldValuesChange = async (name, value) => {
    this.customSelectHandleChange(name, value);
    const { projectId } = this.props;
    if (value && ['reference', 'dynamic_option'].includes(value.type)) {
      const { refCollection } = value;
      const { data } = await getItemsOfSelectedCollection(projectId, refCollection.collectionName);
      this.setState({ selectedRefCollectionFieldItems: data ? data : [] });
    }
  };

  getFieldsValue = () => {
    const {
      selectedCollectionFieldItems,
      selectedValueCollectionField,
      selectedRefCollectionFieldItems,
    } = this.state;
    let fieldValues = [];
    if (['reference', 'dynamic_option'].includes(selectedValueCollectionField.type)) {
      const { refCollection } = selectedValueCollectionField;
      selectedRefCollectionFieldItems.forEach((item) => {
        fieldValues.push({
          value: item[refCollection.collectionField],
          uuid: item.uuid,
        });
      });
    } else if (selectedValueCollectionField.type === 'static_option') {
      selectedValueCollectionField.staticOptions.map((opt) => {
        fieldValues.push({
          value: opt,
          uuid: opt,
        });
      });
    } else {
      selectedCollectionFieldItems.forEach((item) => {
        fieldValues.push({
          value: item[selectedValueCollectionField.value],
          uuid: item.uuid,
        });
      });
    }
    return fieldValues;
  };

  showSelectedCollectionFieldValues = (setFieldValue, setFieldTouched) => {
    const { selectedValueCollectionField, isMulti, selectedValueCollectionFieldValue } = this.state;
    if (selectedValueCollectionField) {
      let fieldValues = [];
      fieldValues = this.getFieldsValue();
      fieldValues = fieldValues.map((coln) => ({
        label: coln.value,
        value: coln.value,
      }));
      if (!isMulti) {
        fieldValues.push({
          value: 'EXTERNAL',
          label: 'External',
        });
        fieldValues.push({
          value: 'ENTITY',
          label: 'Collection (Browser Storage)',
        });
      }

      return (
        <>
          <FilterFormParentComponent title="Select Value" icon={iconForField('select')}>
            <CustomSelect
              name="selectedValueCollectionFieldValue"
              isMulti={isMulti}
              value={selectedValueCollectionFieldValue}
              options={fieldValues}
              onChangeValue={this.customSelectHandleChange}
              onChange={setFieldValue}
              onBlur={setFieldTouched}
              placeholder="Select Value"
            />
          </FilterFormParentComponent>
          {this.showEntityKeyField(
            selectedValueCollectionFieldValue,
            setFieldValue,
            setFieldTouched,
          )}
          {this.showExternalKeyForMaxValue('collectionFieldValueExternal', 'EXTERNAL')}
        </>
      );
    }
  };

  showSelectedFieldForCollection = (setFieldValue, setFieldTouched) => {
    const { selectedCollectionFields, selectedValueCollectionField } = this.state;
    return (
      <FilterFormParentComponent title="Select Field" icon={iconForField('select')}>
        <CustomSelect
          name="selectedValueCollectionField"
          isMulti={false}
          value={selectedValueCollectionField}
          options={[
            ...selectedCollectionFields.map((coln) => ({
              label: coln.name,
              value: coln.value,
              type: coln.type,
              refCollection: coln.refCollection,
              staticOptions: coln.staticOptions,
            })),
          ]}
          onChangeValue={this.handleFieldValuesChange}
          onChange={setFieldValue}
          onBlur={setFieldTouched}
          placeholder="Select Field"
        />
      </FilterFormParentComponent>
    );
  };

  showFieldOrFilter = (setFieldValue, setFieldTouched) => {
    const { choiceOfFieldSelect, selectedValueCollection } = this.state;
    if (!choiceOfFieldSelect) {
      return '';
    }
    if (choiceOfFieldSelect.value === 'CHOOSE_FIELD') {
      if (CURRENTS.includes(selectedValueCollection.value)) {
        return this.showSelectedFieldForCollection(setFieldValue, setFieldTouched);
      } else {
        return (
          <>
            {this.showSelectedFieldForCollection(setFieldValue, setFieldTouched)}
            {this.showSelectedCollectionFieldValues(setFieldValue, setFieldTouched)}
          </>
        );
      }
    }
    if (choiceOfFieldSelect.value === 'CHOOSE_FILTER') {
      return this.showSelectedCollectionFilter(setFieldValue, setFieldTouched);
    }
  };

  showSelectedCollectionFilter = (setFieldValue, setFieldTouched) => {
    const {
      selectedCollectionFieldItems,
      selectedValueCollectionField,
      selectedValueCollectionFilterValue,
      selectedCollectionFilters,
    } = this.state;
    return (
      <FilterFormParentComponent title="Select Filter" icon={iconForField('select')}>
        <CustomSelect
          name="selectedValueCollectionFilterValue"
          isMulti={false}
          value={selectedValueCollectionFilterValue}
          options={selectedCollectionFilters}
          onChangeValue={this.customSelectHandleChange}
          onChange={setFieldValue}
          onBlur={setFieldTouched}
          placeholder="Select Filter"
        />
      </FilterFormParentComponent>
    );
  };

  showChoiceOfFieldAndFilter = (setFieldValue, setFieldTouched) => {
    const { selectedValueCollection } = this.state;
    const { rls } = this.props;
    let options = [
      {
        label: 'Choose Field',
        value: 'CHOOSE_FIELD',
      },
      {
        label: 'Choose Filter',
        value: 'CHOOSE_FILTER',
      },
    ];
    if (rls) {
      options = [{ label: 'Choose Field', value: 'CHOOSE_FIELD' }];
    }
    return (
      <FilterFormParentComponent title="Select Option" icon={iconForField('select')}>
        <CustomSelect
          name="choiceOfFieldSelect"
          isMulti={false}
          value={this.state.choiceOfFieldSelect}
          options={options}
          onChangeValue={this.customSelectHandleChange}
          onChange={setFieldValue}
          onBlur={setFieldTouched}
          placeholder="Choose Option"
        />
      </FilterFormParentComponent>
    );
  };

  collectionOptions = () => {
    let options = [];
    options = this.props.collections.projectCollections.map((coll) => ({
      label: coll.collectionTitle,
      value: coll.collectionName,
    }));
    return options;
  };

  collectionFieldsForEntity = () => {
    const { customEntityKey } = this.state;
    const {
      collections: { projectCollections },
    } = this.props;
    let options = [];
    if (customEntityKey && customEntityKey.value) {
      const entityCollection = projectCollections.find(
        (coll) => coll.collectionName === customEntityKey.value,
      );
      const collectionFields = entityCollection.fields.map((field) => ({
        label: field.fieldTitle.en,
        value: field.fieldName,
      }));
      const referenceFields = extractRefField(
        entityCollection.fields,
        projectCollections,
        [],
        false,
      ).map((field) => ({
        value: `${field.fieldName}`,
        label: field.fieldTitle,
      }));
      const derivedFields = entityCollection.utilities.map((field) => ({
        value: `DF::${field.name}`,
        label: field.name,
      }));
      options = [
        { label: 'Collection Field', options: [...collectionFields] },
        { label: 'Reference Field', options: [...referenceFields] },
        { label: 'Derived Field', options: [...derivedFields] },
      ];
    }
    return options;
  };

  showEntityKeyField = (value, setFieldValue, setFieldTouched) => {
    const { entityItemPathError, customEntityKey, entityItemPath } = this.state;
    if (value && value.value === 'ENTITY') {
      return (
        <>
          <FilterFormParentComponent
            title="Custom Collection (Browser Storage) Key"
            icon={iconForField('text')}
          >
            <CustomSelect
              name="customEntityKey"
              isMulti={false}
              value={customEntityKey ? customEntityKey : ''}
              options={this.collectionOptions()}
              onChangeValue={this.customSelectHandleChange}
              onChange={setFieldValue}
              onBlur={setFieldTouched}
              placeholder="Select Collection"
            />
          </FilterFormParentComponent>
          <FilterFormParentComponent title="JSON path of the Item" icon={iconForField('text')}>
            <CustomSelect
              name="entityItemPath"
              isMulti={false}
              value={entityItemPath ? entityItemPath : ''}
              options={this.collectionFieldsForEntity()}
              onChangeValue={this.customSelectHandleChange}
              onChange={setFieldValue}
              onBlur={setFieldTouched}
              placeholder="Select Field"
            />
            {entityItemPathError && <p className="text-error">{entityItemPathError}</p>}
          </FilterFormParentComponent>
        </>
      );
    } else return '';
  };

  showDateConstantField = (externalKeyName) => {
    const { selectedValue, selectedValueMin, selectedValueMax, selectedField } = this.state;
    if (selectedField && defaultFields2.includes(selectedField.type)) {
      let value = '';
      let name = externalKeyName;
      if (!externalKeyName) {
        if (selectedValue) value = selectedValue.value;
        name = 'dateUnitNum';
      } else if (externalKeyName.includes('min') && selectedValueMin) {
        value = selectedValueMin.value;
      } else if (externalKeyName.includes('max') && selectedValueMax) {
        value = selectedValueMax.value;
      }
      if (value && !DateTimeUnit.includes(value)) return '';
      return (
        <FilterFormParentComponent
          title={value ? `Number of ${snakeCaseToTitleCase(value)}s` : ''}
          icon={iconForField('number')}
        >
          <input
            type="number"
            className="form-control form-control-sm"
            name={name}
            placeholder={value ? `Number of ${snakeCaseToTitleCase(value)}s` : ''}
            onChange={(e) => this.setState({ [name]: e.target.value })}
          />
        </FilterFormParentComponent>
      );
    } else return '';
  };

  showDateConstantType = (setFieldValue, setFieldTouched, externalKeyName) => {
    const { selectedValue, selectedValueMin, selectedValueMax, selectedField } = this.state;
    if (selectedField && defaultFields2.includes(selectedField.type)) {
      let value = '';
      let name = externalKeyName;
      let dateConstantType = this.state[externalKeyName];
      if (!externalKeyName) {
        if (selectedValue) value = selectedValue.value;
        name = 'dateConstantType';
        dateConstantType = this.state['dateConstantType'];
      } else if (externalKeyName.includes('min') && selectedValueMin) {
        value = selectedValueMin.value;
      } else if (externalKeyName.includes('max') && selectedValueMax) {
        value = selectedValueMax.value;
      }
      if (value && !DateTimeUnit.includes(value)) return '';

      return (
        <>
          <FilterFormParentComponent
            title="Custom Collection (Browser Storage) Key"
            icon={iconForField('text')}
          >
            <CustomSelect
              name={name}
              isMulti={false}
              value={dateConstantType ? dateConstantType : ''}
              options={dateConstantTypes}
              onChangeValue={(name, value) => this.setState({ [name]: value })}
              onChange={setFieldValue}
              onBlur={setFieldTouched}
              placeholder="Select Type"
            />
          </FilterFormParentComponent>
        </>
      );
    }
  };

  showSelectorForDynamicOption = (setFieldValue, setFieldTouched, fieldType) => {
    const {
      selectedValueError,
      selectedField,
      isMulti,
      selectedValueCollection,
      selectedCondition,
    } = this.state;
    if (selectedCondition.value === IS_NOT_NULL || selectedCondition.value === IS_NULL) {
      return;
    }

    let { projectCollections } = this.props.collections;
    if (referenceTypeArray.includes(fieldType)) {
      const { fields, projectId } = this.props;
      const selectedFieldDetails = fields.find((field) => field.fieldName === selectedField.value);
      if (!Object.keys(selectedFieldDetails).length) {
        return '';
      }

      projectCollections = [
        projectCollections.find(
          (collection) =>
            collection.collectionName === selectedFieldDetails.refCollection.collectionName,
        ),
      ];
      projectCollections.push({
        collectionTitle: 'Current LoggedIn User',
        collectionName: CURRENT_USER,
      });
      projectCollections.push({
        collectionTitle: 'Current LoggedIn User Tenant',
        collectionName: CURRENT_TENANT,
      });
      projectCollections.push({
        collectionTitle: 'Current LoggedIn User Settings',
        collectionName: CURRENT_SETTINGS,
      });
      projectCollections.push({
        collectionTitle: 'Current LoggedIn Sub Tenant',
        collectionName: CURRENT_SUB_TENANT,
      });
    }

    return (
      <>
        <FilterFormParentComponent title="Select Collection" icon={iconForField('select')}>
          <CustomSelect
            name="selectedValueCollection"
            isMulti={false}
            value={selectedValueCollection}
            options={[
              ...projectCollections.map((coln) => ({
                label: coln.collectionTitle,
                value: coln.collectionName,
              })),
            ]}
            onChangeValue={this.handleCollectionChange}
            onChange={setFieldValue}
            onBlur={setFieldTouched}
            placeholder="Select Collection"
          />
        </FilterFormParentComponent>
        {this.showChoiceOfFieldAndFilter(setFieldValue, setFieldTouched)}
        {this.showFieldOrFilter(setFieldValue, setFieldTouched)}
        {selectedValueError && <p className="text-error">{selectedValueError}</p>}
      </>
    );
  };

  showMinMaxValueSelector = (options, name, placeholder, setFieldValue, setFieldTouched) => {
    return (
      <CustomSelect
        name={name}
        isMulti={false}
        value={this.state[name]}
        options={options}
        onChangeValue={this.customSelectHandleChange}
        onChange={setFieldValue}
        onBlur={setFieldTouched}
        placeholder={placeholder}
      />
    );
  };

  showExternalKeyForMaxValue = (externalKeyName, valueType) => {
    const {
      selectedValue,
      selectedValueMin,
      selectedValueMax,
      selectedValueCollectionFieldValue,
      selectedCondition,
    } = this.state;

    const checkValues = [];
    if (selectedValue) {
      checkValues.push(selectedValue.value);
    }
    if (selectedValueMin) {
      checkValues.push(selectedValueMin.value);
    }

    if (selectedValueMax) {
      checkValues.push(selectedValueMax.value);
    }
    if (selectedValueCollectionFieldValue) {
      checkValues.push(selectedValueCollectionFieldValue.value);
    }

    let type = 'text';
    let title = '';
    let isShow = false;
    if (checkValues.includes(valueType)) {
      isShow = true;
      if (valueType === 'EXTERNAL') {
        title = 'External Params Key';
      } else if (valueType === 'FIXED_VALUE') {
        type = 'number';
        title = 'Fixed Value';
      }
    }
    if (selectedCondition.value === 'BETWEEN') {
      isShow = selectedValueMin.value === selectedValueMax.value;
      if (isShow) {
        if (
          selectedValueMin.value === 'EXTERNAL' &&
          ['minExternal', 'maxExternal'].includes(externalKeyName)
        ) {
          isShow = true;
        } else if (
          selectedValueMin.value === 'FIXED_VALUE' &&
          ['minFixedValue', 'maxFixedValue'].includes(externalKeyName)
        ) {
          isShow = true;
        } else isShow = false;
      }
    }

    return isShow ? (
      <FilterFormParentComponent title={title} icon={iconForField(type)}>
        <input
          type={type}
          className="form-control form-control-sm"
          name={externalKeyName}
          placeholder={title}
          onChange={this.handleExternalKeyChange}
        />
      </FilterFormParentComponent>
    ) : (
      ''
    );
  };

  showCurrentUserRefField = (setFieldValue, setFieldTouched) => {
    const {
      selectedCurrentUserRefFieldError,
      selectedCurrentUserRefField,
      selectedCurrentUserRef,
    } = this.state;

    if (!selectedCurrentUserRef || selectedCurrentUserRef.value === 'uuid') {
      return '';
    }
    if (
      !isFieldIsCollectionRefField(
        this.props.collections.projectCollections,
        'user',
        selectedCurrentUserRef.value,
      )
    ) {
      return;
    }
    const refCollectionOptions = collectionRefFieldOption(
      this.props.collections.projectCollections,
      'user',
      selectedCurrentUserRef.value,
    );

    return (
      <FilterFormParentComponent
        title="Select Current LoggedIn User Field"
        icon={iconForField('select')}
      >
        <CustomSelect
          name="selectedCurrentUserRefField"
          isMulti={false}
          value={selectedCurrentUserRefField}
          options={refCollectionOptions}
          onChangeValue={this.customSelectHandleChange}
          onChange={setFieldValue}
          onBlur={setFieldTouched}
          placeholder={'Value'}
        />
        {selectedCurrentUserRefFieldError && (
          <p className="text-error">{selectedCurrentUserRefFieldError}</p>
        )}
      </FilterFormParentComponent>
    );
  };

  showCurrentUserRelatedSelector = (
    setFieldValue,
    setFieldTouched,
    isStaticFieldAllowed = false,
  ) => {
    let {
      selectedField,
      selectedCondition,
      selectedValue,
      selectedCurrentUserRefError,
      selectedCurrentUserRef,
      isMulti,
    } = this.state;

    if (!selectedValue || selectedValue.length === 0) {
      return '';
    }
    if (isMulti) {
      selectedValue = selectedValue[0];
    }

    if (selectedValue.value !== CURRENT_USER) {
      return '';
    }
    if (selectedField.value === 'createdBy' || selectedField.value === 'createdby') {
      return '';
    }
    const selectedCurrentUserOptions = collectionRefFields(
      this.props.collections.projectCollections,
      'user',
      isStaticFieldAllowed,
    );
    if (!selectedCurrentUserOptions) {
      return '';
    }

    return (
      <>
        <FilterFormParentComponent
          title="Select Current LoggedIn User Field"
          icon={iconForField('select')}
        >
          <CustomSelect
            name="selectedCurrentUserRef"
            isMulti={false}
            value={selectedCurrentUserRef}
            options={selectedCurrentUserOptions}
            onChangeValue={this.customSelectHandleChange}
            onChange={setFieldValue}
            onBlur={setFieldTouched}
            placeholder={'Value'}
          />
          {selectedCurrentUserRefError && (
            <p className="text-error">{selectedCurrentUserRefError}</p>
          )}
        </FilterFormParentComponent>
        {this.showCurrentUserRefField(setFieldValue, setFieldTouched)}
      </>
    );
  };

  showCurrentUserTenantRefField = (setFieldValue, setFieldTouched) => {
    const {
      selectedCurrentUserRefFieldError,
      selectedCurrentUserRefField,
      selectedCurrentUserRef,
      multiTenantCollection,
    } = this.state;
    const { projectCollections } = this.props.collections;

    if (!selectedCurrentUserRef || selectedCurrentUserRef.value === 'uuid') return '';
    if (
      !isFieldIsCollectionRefField(
        projectCollections,
        multiTenantCollection,
        selectedCurrentUserRef.value,
      )
    )
      return;
    const refCollectionOptions = collectionRefFieldOption(
      this.props.collections.projectCollections,
      multiTenantCollection,
      selectedCurrentUserRef.value,
    );

    return (
      <FilterFormParentComponent
        title="Select Current LoggedIn User Field"
        icon={iconForField('select')}
      >
        <CustomSelect
          name="selectedCurrentUserRefField"
          isMulti={false}
          value={selectedCurrentUserRefField}
          options={refCollectionOptions}
          onChangeValue={this.customSelectHandleChange}
          onChange={setFieldValue}
          onBlur={setFieldTouched}
          placeholder={'Value'}
        />
        {selectedCurrentUserRefFieldError && (
          <p className="text-error">{selectedCurrentUserRefFieldError}</p>
        )}
      </FilterFormParentComponent>
    );
  };

  showCurrentUserTenantRelatedSelector = (
    setFieldValue,
    setFieldTouched,
    isStaticFieldAllowed = false,
  ) => {
    let {
      selectedValue,
      selectedCurrentUserRefError,
      selectedCurrentUserRef,
      isMulti,
      multiTenantCollection,
    } = this.state;
    if (!selectedValue || selectedValue.length === 0) return '';
    if (isMulti) selectedValue = selectedValue[0];
    if (selectedValue.value !== CURRENT_TENANT) return '';

    const selectedCurrentUserTenantOptions = collectionRefFields(
      this.props.collections.projectCollections,
      multiTenantCollection,
      isStaticFieldAllowed,
    );
    if (!selectedCurrentUserTenantOptions) return '';

    return (
      <>
        <FilterFormParentComponent
          title="Select Current LoggedIn User Tenant Field"
          icon={iconForField('select')}
        >
          <CustomSelect
            name="selectedCurrentUserRef"
            isMulti={false}
            value={selectedCurrentUserRef}
            options={selectedCurrentUserTenantOptions}
            onChangeValue={this.customSelectHandleChange}
            onChange={setFieldValue}
            onBlur={setFieldTouched}
            placeholder={'Value'}
          />
          {selectedCurrentUserRefError && (
            <p className="text-error">{selectedCurrentUserRefError}</p>
          )}
        </FilterFormParentComponent>
        {this.showCurrentUserTenantRefField(setFieldValue, setFieldTouched)}
      </>
    );
  };

  showCurrentUserSettingsRefField = (setFieldValue, setFieldTouched) => {
    const {
      selectedCurrentUserRefFieldError,
      selectedCurrentUserRefField,
      selectedCurrentUserRef,
      userSettingsCollection,
    } = this.state;
    const { projectCollections } = this.props.collections;

    if (!selectedCurrentUserRef || selectedCurrentUserRef.value === 'uuid') return '';
    if (
      !isFieldIsCollectionRefField(
        projectCollections,
        userSettingsCollection,
        selectedCurrentUserRef.value,
      )
    )
      return;
    const refCollectionOptions = collectionRefFieldOption(
      this.props.collections.projectCollections,
      userSettingsCollection,
      selectedCurrentUserRef.value,
    );

    return (
      <FilterFormParentComponent
        title="Select Current LoggedIn User Field"
        icon={iconForField('select')}
      >
        <CustomSelect
          name="selectedCurrentUserRefField"
          isMulti={false}
          value={selectedCurrentUserRefField}
          options={refCollectionOptions}
          onChangeValue={this.customSelectHandleChange}
          onChange={setFieldValue}
          onBlur={setFieldTouched}
          placeholder={'Value'}
        />
        {selectedCurrentUserRefFieldError && (
          <p className="text-error">{selectedCurrentUserRefFieldError}</p>
        )}
      </FilterFormParentComponent>
    );
  };

  showCurrentUserSettingsRelatedSelector = (
    setFieldValue,
    setFieldTouched,
    isStaticFieldAllowed = false,
  ) => {
    let {
      selectedValue,
      selectedCurrentUserRefError,
      selectedCurrentUserRef,
      isMulti,
      userSettingsCollection,
    } = this.state;
    if (!selectedValue || selectedValue.length === 0) return '';
    if (isMulti) selectedValue = selectedValue[0];
    if (selectedValue.value !== CURRENT_SETTINGS) return '';

    const selectedCurrentUserSettingsOptions = collectionRefFields(
      this.props.collections.projectCollections,
      userSettingsCollection,
      isStaticFieldAllowed,
    );
    if (!selectedCurrentUserSettingsOptions) return '';

    return (
      <>
        <FilterFormParentComponent
          title="Select Current LoggedIn User Settings Field"
          icon={iconForField('select')}
        >
          <CustomSelect
            name="selectedCurrentUserRef"
            isMulti={false}
            value={selectedCurrentUserRef}
            options={selectedCurrentUserSettingsOptions}
            onChangeValue={this.customSelectHandleChange}
            onChange={setFieldValue}
            onBlur={setFieldTouched}
            placeholder={'Value'}
          />
          {selectedCurrentUserRefError && (
            <p className="text-error">{selectedCurrentUserRefError}</p>
          )}
        </FilterFormParentComponent>
        {this.showCurrentUserSettingsRefField(setFieldValue, setFieldTouched)}
      </>
    );
  };

  showCurrentSubTenantRefField = (setFieldValue, setFieldTouched) => {
    const {
      selectedCurrentUserRefFieldError,
      selectedCurrentUserRefField,
      selectedCurrentUserRef,
      subTenantCollection,
    } = this.state;
    const { projectCollections } = this.props.collections;

    if (!selectedCurrentUserRef || selectedCurrentUserRef.value === 'uuid') return '';
    if (
      !isFieldIsCollectionRefField(
        projectCollections,
        subTenantCollection,
        selectedCurrentUserRef.value,
      )
    )
      return;
    const refCollectionOptions = collectionRefFieldOption(
      this.props.collections.projectCollections,
      subTenantCollection,
      selectedCurrentUserRef.value,
    );

    return (
      <FilterFormParentComponent
        title="Select Current LoggedIn User Field"
        icon={iconForField('select')}
      >
        <CustomSelect
          name="selectedCurrentUserRefField"
          isMulti={false}
          value={selectedCurrentUserRefField}
          options={refCollectionOptions}
          onChangeValue={this.customSelectHandleChange}
          onChange={setFieldValue}
          onBlur={setFieldTouched}
          placeholder={'Value'}
        />
        {selectedCurrentUserRefFieldError && (
          <p className="text-error">{selectedCurrentUserRefFieldError}</p>
        )}
      </FilterFormParentComponent>
    );
  };

  showCurrentSubTenantRelatedSelector = (
    setFieldValue,
    setFieldTouched,
    isStaticFieldAllowed = false,
  ) => {
    let {
      selectedValue,
      selectedCurrentUserRefError,
      selectedCurrentUserRef,
      isMulti,
      subTenantCollection,
    } = this.state;
    if (!selectedValue || selectedValue.length === 0) return '';
    if (isMulti) selectedValue = selectedValue[0];
    if (selectedValue.value !== CURRENT_SUB_TENANT) return '';

    const selectedCurrentSubTenantOptions = collectionRefFields(
      this.props.collections.projectCollections,
      subTenantCollection,
      isStaticFieldAllowed,
    );
    if (!selectedCurrentSubTenantOptions) return '';

    return (
      <>
        <FilterFormParentComponent
          title="Select Current LoggedIn Sub Tenant Field"
          icon={iconForField('select')}
        >
          <CustomSelect
            name="selectedCurrentUserRef"
            isMulti={false}
            value={selectedCurrentUserRef}
            options={selectedCurrentSubTenantOptions}
            onChangeValue={this.customSelectHandleChange}
            onChange={setFieldValue}
            onBlur={setFieldTouched}
            placeholder={'Value'}
          />
          {selectedCurrentUserRefError && (
            <p className="text-error">{selectedCurrentUserRefError}</p>
          )}
        </FilterFormParentComponent>
        {this.showCurrentSubTenantRefField(setFieldValue, setFieldTouched)}
      </>
    );
  };

  showInputForValues = (setFieldValue, setFieldTouched) => {
    const {
      selectedField,
      selectedCondition,
      selectedValueError,
      isMulti,
      selectedValue,
      multiTenantCollection,
      collectionFieldItems,
      userSettingsCollection,
      subTenantCollection,
    } = this.state;
    const availableValues = supportedValues(
      this.props.constants,
      this.props.fields,
      selectedField.value,
      selectedCondition,
      multiTenantCollection,
      userSettingsCollection,
      subTenantCollection,
    );
    let valueSelectForm = '';
    const selectValues = [...collectionFieldItems, ...availableValues];
    if (selectValues.length === 0) return '';
    const selectValueOptions = selectValues.map((val) => {
      return { label: val.name, value: val.value };
    });
    let isStaticFieldAllowed = false;
    if ([IN_LIST, NOT_IN_LIST].includes(selectedCondition.value)) isStaticFieldAllowed = true;

    if (selectedCondition.value === 'BETWEEN') {
      let minLabel = 'Min Value';
      let maxLabel = 'Max Value';
      const isDateType = selectedField && defaultFields2.includes(selectedField.type);
      if (isDateType) {
        minLabel = 'Unit';
        maxLabel = 'Unit';
      }

      return (
        <>
          <FilterFormParentComponent title="Select Min Value" icon={iconForField('select')}>
            {this.showMinMaxValueSelector(
              selectValueOptions,
              'selectedValueMin',
              minLabel,
              setFieldValue,
              setFieldTouched,
            )}
            {selectedValueError && <p className="text-error">{selectedValueError}</p>}
          </FilterFormParentComponent>
          {this.showDateConstantField('minDateUnitNum')}{' '}
          {this.showDateConstantType(setFieldValue, setFieldTouched, 'minDateConstantType')}
          {this.showExternalKeyForMaxValue('minExternal', 'EXTERNAL')}
          {this.showExternalKeyForMaxValue('minFixedValue', 'FIXED_VALUE')}
          {''}
          {isDateType && <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12"></div>}
          <FilterFormParentComponent title="Select Max Value" icon={iconForField('select')}>
            {this.showMinMaxValueSelector(
              selectValueOptions,
              'selectedValueMax',
              maxLabel,
              setFieldValue,
              setFieldTouched,
            )}
            {selectedValueError && <p className="text-error">{selectedValueError}</p>}
          </FilterFormParentComponent>
          {this.showDateConstantField('maxDateUnitNum')}{' '}
          {this.showDateConstantType(setFieldValue, setFieldTouched, 'maxDateConstantType')}
          {this.showExternalKeyForMaxValue('maxExternal', 'EXTERNAL')}
          {this.showExternalKeyForMaxValue('maxFixedValue', 'FIXED_VALUE')}
          {''}
        </>
      );
    } else {
      console.log('selectValueOptions', selectValueOptions);
      return (
        <>
          <FilterFormParentComponent title="Select Value" icon={iconForField('select')}>
            <CustomSelect
              name="selectedValue"
              isMulti={isMulti}
              value={selectedValue}
              options={selectValueOptions}
              onChangeValue={this.customSelectHandleChange}
              onChange={setFieldValue}
              onBlur={setFieldTouched}
              placeholder={'Value'}
            />
            {selectedValueError && <p className="text-error">{selectedValueError}</p>}
          </FilterFormParentComponent>
          {this.showDateConstantField()} {this.showDateConstantType(setFieldValue, setFieldTouched)}
          {this.showEntityKeyField(selectedValue, setFieldValue, setFieldTouched)}
          {this.showCurrentUserRelatedSelector(
            setFieldValue,
            setFieldTouched,
            isStaticFieldAllowed,
          )}
          {this.showCurrentUserTenantRelatedSelector(
            setFieldValue,
            setFieldTouched,
            isStaticFieldAllowed,
          )}
          {this.showCurrentUserSettingsRelatedSelector(
            setFieldValue,
            setFieldTouched,
            isStaticFieldAllowed,
          )}
          {this.showCurrentSubTenantRelatedSelector(
            setFieldValue,
            setFieldTouched,
            isStaticFieldAllowed,
          )}
          {this.showExternalKeyForMaxValue('valueExternal', 'EXTERNAL')}
          {this.showExternalKeyForMaxValue('valueFixedValue', 'FIXED_VALUE')}
        </>
      );
    }
  };

  showSupportedValue = (setFieldValue, setFieldTouched) => {
    const { selectedField, selectedCondition } = this.state;
    const fieldType = findTypeOfField(this.props.fields, selectedField.value);
    if (!selectedCondition) {
      return '';
    }
    if (referenceTypeArray.includes(fieldType)) {
      return this.showSelectorForDynamicOption(setFieldValue, setFieldTouched, fieldType);
    } else {
      return this.showInputForValues(setFieldValue, setFieldTouched);
    }
  };

  showSupportedCondition = (setFieldValue, setFieldTouched) => {
    const { selectedField, selectedConditionError } = this.state;
    if (!selectedField) {
      return '';
    }

    let conditions = supportedConditions(this.props.fields, selectedField.value);
    conditions = conditions.map((condition) => {
      return {
        label:
          condition === 'IN_LIST'
            ? `${snakeCaseToTitleCase(condition)} (Any item in list)`
            : snakeCaseToTitleCase(condition),
        value: condition,
      };
    });
    return (
      <>
        <FilterFormParentComponent title="Select Condition" icon={iconForField('select')}>
          <CustomSelect
            name="selectedCondition"
            isMulti={false}
            value={this.state.selectedCondition}
            options={conditions}
            onChangeValue={this.customConditionHandleChange}
            onChange={setFieldValue}
            onBlur={setFieldTouched}
            placeholder="Condition"
          />
          {selectedConditionError && <p className="text-error">{selectedConditionError}</p>}
        </FilterFormParentComponent>
        <br />
        {this.showSupportedValue(setFieldValue, setFieldTouched)}
      </>
    );
  };

  showSaveButton = () => {
    const showButton = showSaveButtonUtil(this.props, this.state);
    const { condition } = this.props;
    if (showButton) {
      return (
        <button
          onClick={this.saveQuery}
          type="button"
          className="btn btn-sm btn-theme-submit"
          title="Save Query"
        >
          <i className="wb webconnect-save-regular"></i>&nbsp;Save
        </button>
      );
    }
  };

  render() {
    const { fieldOptions, condition, setFieldValue, setFieldTouched } = this.props;
    const { conjuctionTypeError, selectedFieldError, selectedField } = this.state;
    if (!fieldOptions) {
      return '';
    }
    return (
      <>
        {condition.id > 1 && (
          <FilterFormParentComponent title="Select JoinBy" icon={iconForField('select')}>
            <CustomSelect
              name="conjuctionType"
              isMulti={false}
              value={this.state.conjuctionType}
              options={[
                { label: 'Conjuction', value: '' },
                { label: 'AND', value: 'AND' },
                { label: 'OR', value: 'OR' },
              ]}
              onChangeValue={this.customSelectHandleChange}
              onChange={setFieldValue}
              onBlur={setFieldTouched}
              placeholder="JoinBy"
            />
            {conjuctionTypeError && <p className="text-error">{conjuctionTypeError}</p>}
          </FilterFormParentComponent>
        )}
        <FilterFormParentComponent title="Select Field" icon={iconForField('select')}>
          <CustomSelect
            name="selectedField"
            isMulti={false}
            value={selectedField}
            options={[
              ...fieldOptions.map((field) => {
                return { label: field.label, value: field.value, type: field.type };
              }),
            ]}
            onChangeValue={this.customSelectHandleChange}
            onChange={setFieldValue}
            onBlur={setFieldTouched}
            placeholder="Field"
          />
          {selectedFieldError && <p className="text-error">{selectedFieldError}</p>}
        </FilterFormParentComponent>
        {this.showSupportedCondition(setFieldValue, setFieldTouched)}
        <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 text-right">
          <div className="form-group">
            <button
              onClick={this.removeQuery}
              type="button"
              className="btn btn-sm btn-theme-delete"
              title="Delete Query"
            >
              <i className="wb webconnect-trash-regular"></i>&nbsp;Remove
            </button>
            &nbsp;
            {this.showSaveButton()}
          </div>
        </div>
      </>
    );
  }
}
